import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { Intervento } from '../../../models/intervento.model';
import { NGXLogger } from 'ngx-logger';
import { InterventiService } from '../../../services/interventi.service';

@Component({
  selector: 'app-rimodula-richiesto',
  templateUrl: './rimodula-richiesto.component.html',
  styleUrls: ['./rimodula-richiesto.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputNumberModule,
    ToastModule
  ],
  providers: [MessageService, NGXLogger]
})
export class RimodulaRichiestaComponent implements OnInit, OnChanges {
  @Input() visible: boolean = false;
  @Input() intervento: Intervento | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() rimodulato = new EventEmitter<Intervento | null>();
  form!: FormGroup;
  importoComplessivoRimodulato: number = 0;
  importoComplessivoRimodulatoOriginale: number = 0;
  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private logger: NGXLogger,
    private interventoService: InterventiService
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      importoRichiesto: [{ value: this.intervento?.importoRichiesto, disabled: true }],
      importoRimodulato: [0, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['intervento'] && this.form) {
      this.form.patchValue({
        importoRichiesto: this.intervento?.importoRichiesto,
        importoRimodulato: this.intervento?.importoRimodulato ?? 0
      });
    }
  }

  show(intervento: Intervento): void {
    this.intervento = intervento;
    this.importoComplessivoRimodulato          = this.intervento?.richiesta?.importoRimodulato || 0;
    this.importoComplessivoRimodulatoOriginale = this.intervento?.richiesta?.importoRimodulato || 0;

    this.form.get('importoRimodulato')?.valueChanges.subscribe((value) => {
      if(this.intervento?.importoRimodulato && this.intervento?.importoRimodulato > 0){

          this.importoComplessivoRimodulato = Math.round((this.importoComplessivoRimodulatoOriginale - this.intervento?.importoRimodulato + value) * 100) / 100;
      }else{
        this.importoComplessivoRimodulato = Math.round((this.importoComplessivoRimodulatoOriginale + value) * 100) / 100;

      }
      this.logger.info('[RIMODULA RICHIESTA] importoComplessivoRimodulato: ', this.importoComplessivoRimodulato + " Vs " + (this.intervento?.richiesta?.importoContributo ?? 0));

    });
    this.visible = true;
  }

  hide() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  conferma() {
    if (this.form.valid && this.intervento && this.intervento.id) {
      const importo = this.form.get('importoRimodulato')!.value;
      if (importo !== null) {
        this.intervento.importoRimodulato = importo;
         this.interventoService.rimodulaRichiesta(this.intervento).subscribe(
          (response) => {
            this.rimodulato.emit(this.intervento);
            this.hide();
          }
        );
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Inserisci un importo valido'
      });
    }
  }
}
